// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  height: 100%;
  padding: var(--content-margin);
  position: relative;
  display: flex;
  flex-direction: column;
}

.loading-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}

.error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  gap: 16px;
  color: var(--text-secondary);
}
.error-state mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: #ff9800;
}

.inspect-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 16px;
}

.header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.sample-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.sample-label {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-secondary);
}

.sample-input-group {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
  padding: 4px 12px;
}
.sample-input-group input {
  width: 80px;
  background: transparent;
  border: none;
  color: inherit;
  font-size: 14px;
  text-align: right;
  /* Hide spinner buttons */
  -moz-appearance: textfield;
}
.sample-input-group input:focus {
  outline: none;
}
.sample-input-group input::-webkit-outer-spin-button, .sample-input-group input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.sample-input-group .sample-total {
  font-size: 13px;
  color: var(--text-secondary);
  white-space: nowrap;
}

.selectors-row {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}
.selectors-row .dataset-field,
.selectors-row .column-field {
  min-width: 150px;
}
.selectors-row .dataset-field ::ng-deep .mat-mdc-form-field-subscript-wrapper,
.selectors-row .column-field ::ng-deep .mat-mdc-form-field-subscript-wrapper {
  display: none;
}

.column-stats {
  display: flex;
  gap: 24px;
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.stat-label {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-secondary);
}

.stat-value {
  font-size: 13px;
  font-family: "Roboto Mono", monospace;
}

.timestamp {
  margin-left: auto;
  font-size: 12px;
  color: var(--text-secondary);
}

.no-samples {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 24px;
  color: var(--text-secondary);
}
.no-samples mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}

.data-display {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.chart-container {
  height: 100%;
}

app-samples {
  display: block;
  height: 100%;
}

.hidden {
  display: none;
}

::ng-deep .mat-mdc-select-panel {
  background-color: var(--mat-sys-surface-container) !important;
  scrollbar-width: thin !important;
  scrollbar-color: rgba(155, 155, 155, 0.7) transparent !important;
}
::ng-deep .mat-mdc-select-panel::-webkit-scrollbar {
  width: 8px !important;
}
::ng-deep .mat-mdc-select-panel::-webkit-scrollbar-track {
  background: transparent !important;
}
::ng-deep .mat-mdc-select-panel::-webkit-scrollbar-thumb {
  background: rgba(155, 155, 155, 0.7) !important;
  border-radius: 4px !important;
}
::ng-deep .mat-mdc-select-panel::-webkit-scrollbar-thumb:hover {
  background: rgba(155, 155, 155, 0.9) !important;
}
::ng-deep .mat-mdc-select-panel .mat-mdc-option {
  color: var(--mat-sys-on-surface) !important;
}
::ng-deep .mat-mdc-select-panel .mat-mdc-option:hover:not(.mdc-list-item--disabled) {
  background-color: var(--mat-sys-surface-variant) !important;
}
::ng-deep .mat-mdc-select-panel .mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--disabled) {
  background-color: var(--mat-sys-primary-container) !important;
  color: var(--mat-sys-on-primary-container) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/data/inspect/inspect.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;EACA,4BAAA;AACF;AACE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AACJ;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,SAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,4BAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,qCAAA;EACA,kBAAA;EACA,iBAAA;AAAF;AAEE;EACE,WAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EAMA,yBAAA;EAMA,0BAAA;AAVJ;AAAI;EACE,aAAA;AAEN;AAEI;EAEE,wBAAA;EACA,SAAA;AADN;AAME;EACE,eAAA;EACA,4BAAA;EACA,mBAAA;AAJJ;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AATF;AAWE;;EAEE,gBAAA;AATJ;AAWI;;EACE,aAAA;AARN;;AAaA;EACE,aAAA;EACA,SAAA;EACA,iBAAA;EACA,qCAAA;EACA,kBAAA;EACA,0CAAA;AAVF;;AAaA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AAVF;;AAaA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,4BAAA;AAVF;;AAaA;EACE,eAAA;EACA,qCAAA;AAVF;;AAaA;EACE,iBAAA;EACA,eAAA;EACA,4BAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,aAAA;EACA,4BAAA;AAVF;AAYE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAVJ;;AAcA;EACE,OAAA;EACA,aAAA;EACA,gBAAA;AAXF;;AAcA;EACE,YAAA;AAXF;;AAcA;EACE,cAAA;EACA,YAAA;AAXF;;AAcA;EACE,aAAA;AAXF;;AAgBE;EACE,6DAAA;EAGA,gCAAA;EACA,gEAAA;AAfJ;AAiBI;EACE,qBAAA;AAfN;AAkBI;EACE,kCAAA;AAhBN;AAmBI;EACE,+CAAA;EACA,6BAAA;AAjBN;AAmBM;EACE,+CAAA;AAjBR;AAqBI;EACE,2CAAA;AAnBN;AAqBM;EACE,2DAAA;AAnBR;AAsBM;EACE,6DAAA;EACA,qDAAA;AApBR","sourcesContent":[".container {\n  height: 100%;\n  padding: var(--content-margin);\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n.loading-overlay {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 10;\n}\n\n.error-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 200px;\n  gap: 16px;\n  color: var(--text-secondary);\n\n  mat-icon {\n    font-size: 48px;\n    width: 48px;\n    height: 48px;\n    color: #ff9800;\n  }\n}\n\n.inspect-content {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  gap: 16px;\n}\n\n.header-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.sample-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.sample-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-secondary);\n}\n\n.sample-input-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 4px;\n  padding: 4px 12px;\n\n  input {\n    width: 80px;\n    background: transparent;\n    border: none;\n    color: inherit;\n    font-size: 14px;\n    text-align: right;\n\n    &:focus {\n      outline: none;\n    }\n\n    /* Hide spinner buttons */\n    &::-webkit-outer-spin-button,\n    &::-webkit-inner-spin-button {\n      -webkit-appearance: none;\n      margin: 0;\n    }\n    -moz-appearance: textfield;\n  }\n\n  .sample-total {\n    font-size: 13px;\n    color: var(--text-secondary);\n    white-space: nowrap;\n  }\n}\n\n.view-toggle {\n  // Style inherited from mat-button-toggle-group\n}\n\n.selectors-row {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n\n  .dataset-field,\n  .column-field {\n    min-width: 150px;\n\n    ::ng-deep .mat-mdc-form-field-subscript-wrapper {\n      display: none;\n    }\n  }\n}\n\n.column-stats {\n  display: flex;\n  gap: 24px;\n  padding: 8px 16px;\n  background: rgba(255, 255, 255, 0.03);\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.stat {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n}\n\n.stat-label {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--text-secondary);\n}\n\n.stat-value {\n  font-size: 13px;\n  font-family: 'Roboto Mono', monospace;\n}\n\n.timestamp {\n  margin-left: auto;\n  font-size: 12px;\n  color: var(--text-secondary);\n}\n\n.no-samples {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 24px;\n  color: var(--text-secondary);\n\n  mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.data-display {\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.chart-container {\n  height: 100%;\n}\n\napp-samples {\n  display: block;\n  height: 100%;\n}\n\n.hidden {\n  display: none;\n}\n\n// Fix dropdown styling - ensure proper theming and scrollbar\n::ng-deep {\n  .mat-mdc-select-panel {\n    background-color: var(--mat-sys-surface-container) !important;\n\n    // Themed scrollbar for dropdown list\n    scrollbar-width: thin !important;\n    scrollbar-color: rgba(155, 155, 155, 0.7) transparent !important;\n\n    &::-webkit-scrollbar {\n      width: 8px !important;\n    }\n\n    &::-webkit-scrollbar-track {\n      background: transparent !important;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: rgba(155, 155, 155, 0.7) !important;\n      border-radius: 4px !important;\n\n      &:hover {\n        background: rgba(155, 155, 155, 0.9) !important;\n      }\n    }\n\n    .mat-mdc-option {\n      color: var(--mat-sys-on-surface) !important;\n\n      &:hover:not(.mdc-list-item--disabled) {\n        background-color: var(--mat-sys-surface-variant) !important;\n      }\n\n      &.mdc-list-item--selected:not(.mdc-list-item--disabled) {\n        background-color: var(--mat-sys-primary-container) !important;\n        color: var(--mat-sys-on-primary-container) !important;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
